<template>
  <div class="common__pageContainer__3-VhW">
    <div class="common__pageBody__1Dn3a">
      <div class="eGameStyle__egame__E5AS4">
        <div class="eGameStyle__header__3Vlt9">
          <div class="egameStyle__banner__2qo9-">
            <div class="egameStyle__banner_img__2lHHx" style="background-image: url('https://senbackkg.salinent.com/main-consumer-web/assets-oss/ob/images/egaming/banner.bb277373d1c639fff9e30214d9839c9c.png?x-oss-process=image/resize,p_100/quality,Q_70/format,webp')">
              <div class="egameStyle__imgBanner__2VpzZ" style="background-image: url('https://senbackkg.salinent.com/main-consumer-web/assets-oss/commons/images/egame/banner-img-ob.80d5348d9497618f96904fdbd755b6ff.png?x-oss-process=image/resize,m_lfit,w_3840/format,webp'); width: 1920px"></div>
              <div class="egameStyle__numGroup__1D1nc" style="background-image: url('https://senbackkg.salinent.com/main-consumer-web/assets-oss/ob/images/egaming/math.0bd91b02cab946c2726f6aaa9670dbfb.png?x-oss-process=image/resize,p_100/quality,Q_70/format,webp')">
                <div class="egameStyle__numItem__1-2Zp"><span class="egameStyle__numitemNum__3mM7j" style="background-position-y: -440px"></span></div>
                <div class="egameStyle__numItem__1-2Zp"><span class="egameStyle__numitemNum__3mM7j" style="background-position-y: -385px"></span></div>
                <div class="egameStyle__numItem__1-2Zp"><span class="egameStyle__numitemNum__3mM7j" style="background-position-y: -277px"></span></div>
                <div class="egameStyle__numItem__1-2Zp"><span class="egameStyle__numitemNum__3mM7j" style="background-position-y: -223px"></span></div>
                <div class="egameStyle__numItem__1-2Zp"><span class="egameStyle__numitemNum__3mM7j" style="background-position-y: -223px"></span></div>
                <div class="egameStyle__numItem__1-2Zp"><span class="egameStyle__numitemNum__3mM7j" style="background-position-y: -440px"></span></div>
                <div class="egameStyle__numItem__1-2Zp"><span class="egameStyle__numitemNum__3mM7j" style="background-position-y: -115px"></span></div>
                <div class="egameStyle__numItem__1-2Zp"><span class="egameStyle__numitemNum__3mM7j" style="background-position-y: -61px"></span></div>
                <div class="egameStyle__numItem__1-2Zp"><span class="egameStyle__numitemNum__3mM7j" style="background-position-y: -385px"></span></div>
                <div class="egameStyle__numItem__1-2Zp"><span class="egameStyle__numitemNum__3mM7j" style="background-position-y: -115px"></span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="eGameStyle__egame_content__k3HLh">
          <div class="eGameStyle__content__n6sh5" style="z-index: 18">
            <div class="eGameStyle__headerWrapper__w0XEc">
              <ul>
                <li :class="gamecode == null ? 'eGameStyle__active__18JhP' : ''" @click="changgamecode(null)"><span>全部游戏</span></li>
                <li :class="gamecode == 'obgdy' ? 'eGameStyle__active__18JhP' : ''" @click="changgamecode('obgdy')"><span>OB电子</span></li>
                <li :class="gamecode == 'fgdz' ? 'eGameStyle__active__18JhP' : ''" @click="changgamecode('fgdz')"><span>FG电子</span></li>
                <li :class="gamecode == 'pp' ? 'eGameStyle__active__18JhP' : ''" @click="changgamecode('pp')"><span>PP电子</span></li>
                <li :class="gamecode == 'ae' ? 'eGameStyle__active__18JhP' : ''" @click="changgamecode('ae')"><span>AE电子</span></li>
              </ul>
            </div>

            <div class="eGameStyle__pager__M8cuD">
              <ul class="onshow" style="display: flex" v-if="gamecode == null">
                <li v-for="(item, index) in $store.state.conciseList" :key="index">
                  <section class="eGameStyle__game_section__3uTgc">
                    <div class="eGameStyle__game__2G7z7"><img :src="item.api_logo_img" height="130px" style="" /></div>
                    <div class="eGameStyle__game_text__1XVw5">
                      <span>{{ item.name }} </span>
                      <!-- --{{item.platform_name}} -->
                    </div>
                    <div class="eGameStyle__game_cover__2OtQU">
                      <button class="eGameStyle__play_button__2duIt" @click="$parent.openGamePage(item.platform_name, item.game_code, '')">立即游戏</button>
                    </div>
                  </section>
                </li>
              </ul>
              <ul class="noshow" style="display: flex" v-if="gamecode == 'obgdy'">
                <li v-for="(item, index) in obgdyList" :key="index">
                  <section class="eGameStyle__game_section__3uTgc">
                    <div class="eGameStyle__game__2G7z7"><img :src="item.gamepic" height="130px" style="" /></div>
                    <div class="eGameStyle__game_text__1XVw5">
                      <span> {{ item.gamename }}</span>
                    </div>
                    <div class="eGameStyle__game_cover__2OtQU">
                      <button class="eGameStyle__play_button__2duIt" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">立即游戏</button>
                    </div>
                  </section>
                </li>
              </ul>
              <ul class="noshow" style="display: flex" v-if="gamecode == 'fgdz'">
                <li v-for="(item, index) in fgdzList" :key="index">
                  <section class="eGameStyle__game_section__3uTgc">
                    <div class="eGameStyle__game__2G7z7"><img :src="item.gamepic" height="130px" style="" /></div>
                    <div class="eGameStyle__game_text__1XVw5">
                      <span> {{ item.gamename }}</span>
                    </div>
                    <div class="eGameStyle__game_cover__2OtQU">
                      <button class="eGameStyle__play_button__2duIt" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">立即游戏</button>
                    </div>
                  </section>
                </li>
              </ul>
              <ul class="noshow" style="display: flex" v-if="gamecode == 'pp'">
                <li v-for="(item, index) in ppList" :key="index">
                  <section class="eGameStyle__game_section__3uTgc">
                    <div class="eGameStyle__game__2G7z7"><img :src="item.gamepic" height="130px" style="" /></div>
                    <div class="eGameStyle__game_text__1XVw5">
                      <span> {{ item.gamename }}</span>
                    </div>
                    <div class="eGameStyle__game_cover__2OtQU">
                      <button class="eGameStyle__play_button__2duIt" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">立即游戏</button>
                    </div>
                  </section>
                </li>
              </ul>
              <ul class="noshow" style="display: flex" v-if="gamecode == 'ae'">
                <li v-for="(item, index) in aeList" :key="index">
                  <section class="eGameStyle__game_section__3uTgc">
                    <div class="eGameStyle__game__2G7z7"><img :src="item.gamepic" height="130px" style="" /></div>
                    <div class="eGameStyle__game_text__1XVw5">
                      <span> {{ item.gamename }}</span>
                    </div>
                    <div class="eGameStyle__game_cover__2OtQU">
                      <button class="eGameStyle__play_button__2duIt" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">立即游戏</button>
                    </div>
                  </section>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data() {
    return { gamecode: null, obgdyList: [], fgdzList: [], ppList: [], aeList: [] };
  },
  created() {
    let that = this;
    if (this.$route.query) {
      that.gamecode = this.$route.query.type || that.gamecode;
    }
    that.gamelistBycode();
  },
  methods: {
    changgamecode(code) {
      let that = this;
      if (code == that.gamecode) {
        return;
      }

      that.gamecode = code;
      that.gamelistBycode();
    },
    gamelistBycode() {
      let that = this;
      if (!that.gamecode) {
        return;
      }
      let name = that.gamecode + 'List';
      if (that[name].length > 0) {
        return;
      }
      that.$parent.showLoading();
      //  pp ae fg obgdy
      that.$apiFun
        .post('/api/gamelistBycode', { gamecode: that.gamecode })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that[name] = res.data;
          }
          setTimeout(() => {
            that.$parent.hideLoading();
          }, 2000);
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '/static/css/Egame_81ba8019.bc5b4e31.css';
//@import '/style.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/concise.vue